<nav class="navbar dashboard navbar-expand-lg position-relative">
  <div class="d-flex align-items-center">
    <!-- Conditionally show sidebar toggle or logo -->
    
    <i class='bx bx-menu-alt-left d-block d-lg-none fs-2' data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample"></i>
  
    <i v-if="user_details.user_role !== 'user'" class='bx bx-menu fs-5 d-none d-lg-block' @click="toggleSidebar"></i>
    
  </div>
  <ul class="navbar-nav d-flex flex-row ms-auto mb-2 mb-lg-0 align-items-center">
  <li class="nav-item tex-xxs mx-2">
    <a class="text-muted" href="/">
       <img src="@/assets/images/home_dashboard.png" class="w-50" alt="">
    </a>        
  </li>
  <li class="nav-item tex-xxs mx-2">
    <div class="dropdown">
      <button class="avatar-button dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
        <!-- avatar or icon here -->
         {{user_details.first_name.charAt(0)}}
      </button>
      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
        <li><a class="dropdown-item" href="/customer_profile">Profile</a></li>
        <li @click="log_out"><a class="dropdown-item" href="#">Logout</a></li>
      </ul>
    </div>
  </li>
</ul>

</nav>

<div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
  <div class="offcanvas-header">
  </div>
  <div class="offcanvas-body">
    <div class="client-sidebar d-flex flex-column justify-content-between">
      <button 
        type="button" 
        class="btn float-end border-0" 
        data-bs-dismiss="offcanvas" 
        aria-label="Close"
        style="position: absolute; top: 1rem; right: 1rem;"
      >
     <span class="navbar-toggler-icon"></span>
</button>
      <div>
        <div class="logo-details">
          <img :src="$sideLogo" class="img-fluid mx-auto d-block w-70px" alt="">
        </div>
    
        <ul class="nav flex-column mt-5 h-100">
          <!-- Dashboard -->
          <li>
            <router-link to="/dashboard" class="nav-item nav-link active text-decoration-none">
              <i class='bx bx-grid-alt fs-6'></i>Dashboard
            </router-link>
          </li>
          <li class="">
            <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#trust_view" role="button" aria-expanded="false" aria-controls="trust_view">
              <span v-if="cbo_domain" class="">Manage Membership</span>
              <span v-else class=" "><i class='bx bx-command fs-6'></i> <span class="ms-2">Manage Portals</span></span>
              <i class="bx bxs-chevrons-down rotate-icon fs-6"></i>
            </a>
            <ul class="collapse list-unstyled ps-3" id="trust_view">
              <li>
                <router-link to="/create_portal" class="nav-item nav-link text-decoration-none">
                  <i class='bx bxs-chevrons-right fs-6 text-primary'></i> 
                  <span v-if="cbo_domain"class="link-name">Memberships</span>
                <span v-else class="link-name">Portals</span>
                </router-link>
              </li>
              <li v-if="workbook_domain || stagging_domain">
                <router-link to="/manage_roles" class="nav-item nav-link text-decoration-none">
                  <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Roles
                </router-link>
              </li>
            </ul>
          </li>
          <li class="">
            <a class="nav-item nav-link text-decoration-none d-flex justify-content-between" data-bs-toggle="collapse" href="#trustSetupMenu" role="button" aria-expanded="false" aria-controls="trustSetupMenu">
              <span><i class='bx bx-dollar fs-6'></i><span class="ms-2">Manage Profile</span> </span>
              <i class="bx bxs-chevrons-down rotate-icon fs-6"></i>
            </a>
            <ul class="collapse list-unstyled ps-3" id="trustSetupMenu">
              <li>
                <a href="/profile" class="nav-item nav-link text-decoration-none">
                  <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Profile
                </a>
              </li>
            </ul>
          </li>
         
        <!-- Task Management -->
          <li class="">
            <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#tasks" role="button" aria-expanded="false" aria-controls="tasks">
             <span><i class='bx bx-time-five fs-6'></i><span class="ms-2">Manage Events</span></span> 
              <i class="bx bxs-chevrons-down rotate-icon fs-6"></i>
            </a>
            <ul class="collapse list-unstyled ps-3" id="tasks">
              <li>
                <router-link to="/get_rsvps" class="nav-item nav-link text-decoration-none">
                  <i class='bx bxs-chevrons-right fs-6 text-primary'></i>RSVP
                </router-link>
              </li>
            </ul>
          </li>
    
           <!-- Client Management -->
           <li class="" v-if="!cbo_domain">
            <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#clients" role="button" aria-expanded="false" aria-controls="clients">
              <span><i class='bx bx-group fs-6'></i> <span class="ms-2">Group Management</span></span>
              <i class="bx bxs-chevrons-down rotate-icon fs-6"></i>
            </a>
            <ul class="collapse list-unstyled ps-3" id="clients">
              <li v-if="!cbo_domain">
                <router-link to="/create_group" class="nav-item nav-link text-decoration-none">
                  <i class='bx bxs-chevrons-right fs-6 text-primary'></i>Groups
                </router-link>
              </li>
            </ul>
          </li>
    
          <li class="">
            <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#users" role="button" aria-expanded="false" aria-controls="clients">
              <span><i class='bx bx-group fs-6'></i><span class="ms-2">Manage Users</span></span>
              <i class="bx bxs-chevrons-down rotate-icon fs-6"></i>
            </a>
            <ul class="collapse list-unstyled ps-3" id="users">
              <li>
                <router-link to="/create_user" class="nav-item nav-link text-decoration-none">
                  <i class='bx bxs-chevrons-right fs-6 text-primary'></i>Users
                </router-link>
              </li>
            </ul>
          </li>
        
          <!-- System Configuration -->
          <li class="">
            <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#systemConfigMenu" role="button" aria-expanded="false" aria-controls="systemConfigMenu">
              <span><i class='bx bx-cog fs-6'></i> <span class="ms-2">Manage Membership</span></span>
              <i class="bx bxs-chevrons-down rotate-icon fs-6"></i>
            </a>
            <ul class="collapse list-unstyled ps-3" id="systemConfigMenu">
              <li>
                <router-link to="/create_membership" class="nav-item nav-link text-decoration-none  text-xxs">
                  <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Memberships
                </router-link>
              </li>
            </ul>
          </li>
          <li class="">
            <a class="nav-item nav-link text-decoration-none d-flex justify-content-between align-items-center" data-bs-toggle="collapse" href="#questions" role="button" aria-expanded="false" aria-controls="systemConfigMenu">
              <span><i class='bx bx-cog fs-6'></i> <span class="ms-2">Manage Questions</span></span>
              <i class="bx bxs-chevrons-down rotate-icon fs-6"></i>
            </a>
            <ul class="collapse list-unstyled ps-3" id="questions">
              <li>
                <router-link to="/manage_questions" class="nav-item nav-link text-decoration-none  text-xxs">
                  <i class='bx bxs-chevrons-right fs-6 text-primary'></i> Question Bank
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="d-flex justify-content-center mb-3">
        <button @click="log_out" class="btn btn-primary shadow text-xs fw-500 fw-bold rounded-5 mb-5 mx-auto">
          <i class='bx bx-cog'></i>
          <span class="link-name">Logout</span>
        </button>
      </div>
    </div>
  </div>
</div>